import React from 'react';
import Logo from '../assets/ILY.svg'
import cv from '../assets/Cv.pdf'

const Header = () => {
  return (<header className='bg-gray-400 py-5'>
    <div className='container mx-auto'>
      <div className='flex justify-between items-center'>
        {/* logo */}
        <a href='#' id='ilyas'>
          <img id='ilyas' className='lg:ml-12 mt-2 w-[25%]' src={Logo} alt=''/>
        </a>
        
        <a href={"https://drive.google.com/file/d/1R33GR-9sj5QCjbwPakRW8pK4oZDLK1g5/view?usp=drive_link"} target="_blank"> <button className='btn btn-sm'>Download CV</button></a>
      </div>
    </div>
  </header>);
};

export default Header;
